import { z } from 'zod/v3';

// Member DTOs
export const MemberDTOSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  organization: z.string(),
  userId: z.string(),
  user: z.string(),
  role: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
}).strict();

export const MemberListDTOSchema = z.object({
  id: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
}).strict();

export const CreateMemberDTOSchema = z.object({
  organizationId: z.string(),
  organization: z.string(),
  userId: z.string(),
  user: z.string(),
  role: z.string()
}).strict();

export const UpdateMemberDTOSchema = z.object({
  id: z.string(),
  organizationId: z.string().optional(),
  organization: z.string().optional(),
  userId: z.string().optional(),
  user: z.string().optional(),
  role: z.string().optional()
}).strict();

export type MemberDTO = z.infer<typeof MemberDTOSchema>;
export type MemberListDTO = z.infer<typeof MemberListDTOSchema>;
export type CreateMemberDTO = z.infer<typeof CreateMemberDTOSchema>;
export type UpdateMemberDTO = z.infer<typeof UpdateMemberDTOSchema>;
